import React from "react";
import styled, { css } from "styled-components";
import { Theme } from "../theme";
import { hex2rgba } from "../utils/utils";

export const UspsFormControlStyles = css`
    display: block;
    width: 100%;
    height: calc(2.6125rem + 2px);
    padding: 0.65rem 1.3rem;
    font-size: 14px;
    line-height: 1.5;
    color: ${Theme.colors.blue};
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid ${Theme.colors.blue};
    border-radius: 0.2rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:-webkit-autofill {
        -webkit-text-fill-color: ${Theme.colors.blue};
    }
    &:-webkit-autofill:focus {
        -webkit-text-fill-color: ${Theme.colors.blue};
    }

    &::placeholder {
        font-size: 14px;
        color: ${Theme.colors.gray[600]};
    }

    ${(props) =>
        props.as === "textarea" &&
        css`
            height: auto;
        `}

    &:focus {
        color: ${Theme.colors.blue};
        background-color: #fff;
        border-color: #6666b3;
        outline: 0;
        box-shadow: 0 0 0 2px ${Theme.colors.blue};

        ${(props) =>
            props.error &&
            css`
                border-color: ${Theme.colors.red};
                box-shadow: 0 0 0 2px ${hex2rgba(Theme.colors.red, 0.25)};
            `}
    }

    ${(props) =>
        props.error &&
        css`
            background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23e71921'%3E%3Ccircle cx='6' cy='6' r='4.5'/%3E%3Cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3E%3Ccircle cx='6' cy='8.2' r='.6' fill='%23e71921' stroke='none'/%3E%3C/svg%3E");
            background-position: right calc(0.375em + 0.325rem) center;
            background-repeat: no-repeat;
            background-size: calc(0.75em + 0.65rem) calc(0.75em + 0.65rem);
            border-color: ${Theme.colors.red};
            padding-right: calc(1.5em + 1.3rem);
        `}
`;

export const UspsFormControl = styled.input`
    ${UspsFormControlStyles}
`;

UspsFormControl.displayName = "UspsFormControl";
